module.exports = __webpack_public_path__ + "static/feature-3-2ac1f4068e904075dff65a89ddb153f5.png";